<div class="kingster-page-title-wrap  kingster-style-medium kingster-center-align">
  <div class="kingster-header-transparent-substitute"></div>
  <div class="kingster-page-title-overlay"></div>
  <div class="kingster-page-title-container kingster-container">
    <div class="kingster-page-title-content kingster-item-pdlr">
      <div class="kingster-page-caption">Download Forms</div>
      <h1 class="kingster-page-title">Research</h1>
    </div>
  </div>
</div>
<div class="kingster-page-wrapper" id="kingster-page-wrapper">
  <div class=" kingster-sidebar-wrap clearfix kingster-line-height-0 kingster-sidebar-style-left">
    <div class=" kingster-sidebar-center kingster-column-45 kingster-line-height iqac-content">
      <div class="gdlr-core-page-builder-body">
        <div class="gdlr-core-pbf-section">
          <div class="gdlr-core-pbf-section-container gdlr-core-container clearfix">
            <div class="gdlr-core-pbf-element">
              <div
                class="gdlr-core-title-item gdlr-core-item-pdb clearfix  gdlr-core-left-align gdlr-core-title-item-caption-top gdlr-core-item-pdlr"
                style="padding-bottom: 40px ;">
                <div class="gdlr-core-title-item-title-wrap clearfix">
                  <h3 class="gdlr-core-title-item-title gdlr-core-skin-title "
                    style="font-size: 22px ;font-weight: 600 ;letter-spacing: 0px ;text-transform: none ;color: #223d71 ;margin-right: 30px ;">
                    Download Forms</h3>
                  <div class="gdlr-core-title-item-divider gdlr-core-right gdlr-core-skin-divider"
                    style="font-size: 22px ;border-bottom-width: 3px ;"></div>
                </div>
              </div>
            </div>
            <div class="gdlr-core-pbf-wrapper ">
              <div class="gdlr-core-pbf-wrapper-content gdlr-core-js ">
                <div class="gdlr-core-pbf-wrapper-container clearfix gdlr-core-container">
                  <div class="gdlr-core-pbf-element">
                    <div class="gdlr-core-course-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-course-style-list"
                      style="padding-bottom: 45px ;">
                      <app-file-viewer src="https://storage.srnmcollege.ac.in/srnmcweb/research_docs/Utilization%20Certificate.pdf" title="Utilization Certificate"></app-file-viewer>
                      <app-file-viewer src="https://storage.srnmcollege.ac.in/srnmcweb/research_docs/Statement%20of%20Expenditure.pdf" title="Statement of Expenditure"></app-file-viewer>
                      <app-file-viewer src="https://storage.srnmcollege.ac.in/srnmcweb/research_docs/Research%20Proposal%20%20format.pdf" title="Research Proposal format"></app-file-viewer>
                      <app-file-viewer src="https://storage.srnmcollege.ac.in/srnmcweb/research_docs/Progress%20Report.pdf" title="Progress Report"></app-file-viewer>
                      <app-file-viewer src="https://storage.srnmcollege.ac.in/srnmcweb/research_docs/Application%20for%20incentive%20form%20-journal.pdf" title="Application for incentive form - Journal"></app-file-viewer>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <app-research-menu></app-research-menu>
  </div>
</div>